import React from 'react';
import {
    PiFolders,
    PiLayout,
    PiSquaresFour,
    PiTagSimple,
} from 'react-icons/pi';

import { SideNavId, SideNavItem } from '../components/nav/SideNavItem.type';

import ICONS from './icons';
// models
// import { FormulaCategory } from '../models/formula.model';
// constants
import routes from './routes';

export interface SideNavType {
    item: SideNavItem;
    subItems?: SideNavItem[];
}
// TODO: remove these once the formula model is fixed
const enum FormulaCategory {
    Draft = 'Draft',
    Review = 'Review',
    Scheduled = 'Scheduled',
    Live = 'Live',
    Expired = 'Expired',
    Archived = 'Archived',
}

const SideNavItems: SideNavType[] = [
    {
        item: {
            id: SideNavId.Home,
            text: 'Dashboard',
            destination: routes.dashboard,
            icon: <PiSquaresFour size={20} />,
        },
    },
    {
        item: {
            id: SideNavId.TopicManagement,
            text: 'Topic management',
            destination: routes.topicManagement,
            icon: <PiFolders size={20} />,
        },
    },
    {
        item: {
            id: SideNavId.LabelManagement,
            text: 'Components & labels',
            destination: routes.labelManagement,
            icon: <PiTagSimple size={20} />,
        },
    },
    {
        item: {
            id: SideNavId.Messages,
            text: 'Messages',
            destination: routes.formulasMain,
            icon: <ICONS.messages width={20} height={20} />,
        },
        subItems: [
            {
                id: SideNavId.MessagesDrafts,
                text: 'Draft',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Draft,
                ),
            },
            {
                id: SideNavId.MessagesReview,
                text: 'Review',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Review,
                ),
            },
            {
                id: SideNavId.MessageScheduled,
                text: 'Scheduled',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Scheduled,
                ),
            },
            {
                id: SideNavId.MessageLive,
                text: 'Live',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Live,
                ),
            },
            {
                id: SideNavId.MessageExpired,
                text: 'Expired',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Expired,
                ),
            },
            {
                id: SideNavId.MessagesArchived,
                text: 'Archived',
                destination: routes.formulasCatalogWithTabs(
                    FormulaCategory.Archived,
                ),
            },
        ],
    },
    {
        item: {
            id: SideNavId.Surface,
            text: 'Surfaces',
            destination: routes.surface,
            icon: <PiLayout size={20} />,
        },
    },

    {
        item: {
            id: SideNavId.MessageSettings,
            text: 'Message settings',
            destination: routes.messageSettings,
            icon: <ICONS.messageSettings width={20} height={20} />,
        },
        subItems: [
            {
                id: SideNavId.Audiences,
                text: 'Audiences',
                destination: routes.audience,
            },
            {
                id: SideNavId.Datasets,
                text: 'Datasets',
                destination: routes.datasetCatalog,
            },
            {
                id: SideNavId.EmailTemplates,
                text: 'Email templates',
                destination: routes.emailTemplatesCatalog,
            },
            {
                id: SideNavId.Triggers,
                text: 'Triggers',
                destination: routes.compoundTriggers,
            },
        ],
    },
    {
        item: {
            id: SideNavId.Monitoring,
            text: 'Monitoring',
            destination: routes.monitoringMain,
            icon: <ICONS.monitoring width={20} height={20} />,
        },
        subItems: [
            {
                id: SideNavId.Analytics,
                text: 'Analytics',
                destination: routes.optimizedMonitoringMain,
            },
            {
                id: SideNavId.Controlled,
                text: 'Controlled',
                destination: routes.controlledMonitoringMain,
            },
            {
                id: SideNavId.Insights,
                text: 'Insights',
                destination: routes.insightsMonitoringMain,
            },
            {
                id: SideNavId.MessagePerformance,
                text: 'Message performance',
                destination: routes.liveMessages,
            },
            {
                id: SideNavId.SurfacePerformance,
                text: 'Surface performance',
                destination: routes.surfaceMonitoring,
            },
            {
                id: SideNavId.Assignments,
                text: 'Assignments',
                destination: routes.assignmentsMonitoringMain,
            },
        ],
    },
    {
        item: {
            id: SideNavId.SystemSetup,
            text: 'System setup',
            destination: routes.systemSetupMain,
            icon: <ICONS.systemSetup width={20} height={20} />,
        },
        subItems: [
            {
                id: SideNavId.AccountMembers,
                text: 'Account members',
                destination: routes.accountMain,
            },
            {
                id: SideNavId.Attributes,
                text: 'Attributes',
                destination: routes.attributes,
            },
            {
                id: SideNavId.FrequencyLimits,
                text: 'Frequency limits',
                destination: routes.frequencyLimits,
            },
            {
                id: SideNavId.Events,
                text: 'Event management',
                destination: routes.eventsMain,
            },
            {
                id: SideNavId.RewardFunctions,
                text: 'Reward functions',
                destination: routes.rewardFunctionsMain,
                webLink: routes.rewardFunctionsMain,
                nxLink: true,
            },
            {
                id: SideNavId.AuditLog,
                text: 'Audit log',
                destination: routes.auditLog,
            },
            {
                id: SideNavId.Integrations,
                text: 'Integrations',
                destination: routes.integrationMain,
            },
            {
                id: SideNavId.Channels,
                text: 'Channels',
                destination: routes.channelsMain,
            },
            {
                id: SideNavId.Languages,
                text: 'Languages',
                destination: routes.languagesMain,
            },
        ],
    },
    {
        item: {
            id: SideNavId.AampeAdmin,
            text: 'Aampe admin',
            destination: routes.aampeAdmin,
            icon: <ICONS.adminShield width={20} height={20} />,
        },
        subItems: [
            {
                id: SideNavId.CreateCustomer,
                text: 'Create customer',
                destination: routes.aampeAdminCreateCustomer,
            },
        ],
    },
];

export default SideNavItems;
